import React, {FC} from 'react'

const UpdateMaterialVendor: FC = () => {
  return (
    <section id='update-material'>
      <div className='text'>update material</div>
    </section>
  )
}

export {UpdateMaterialVendor}
